import { inject } from '@angular/core';
import { ShellEvents, shellEvent } from '@remote-integration';
import { FeaturesFacade } from '@core/features/facades/features.facade';
import { PermissionsFacade } from '@core/permissions/facades/permissions.facade';
import { ThemeFacade } from '@core/theme/facades/theme.facade';

export const remoteIntegrationShellEventsFactory = (): ShellEvents => ({
  onThemeChange: shellEvent(inject(ThemeFacade).theme),
  onPermissionsChange: shellEvent(inject(PermissionsFacade).permissions),
  onFeaturesChange: shellEvent(inject(FeaturesFacade).features),
});
